// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__+Huz2","small":"Logo_small__vWIXJ","logoText":"Logo_logoText__RZS83"};